// Legacy default department (early task time docs were Technology-only).
export const TASK_TIME_DEPARTMENT = 'Technology';

// Implementation Hours: calls and tasks share ONE pool = strategy call hours.
// (Was 0.5 when Task Time was a separate half-sized allowance.)
export const TASK_TIME_RATIO = 1;

export const TASK_TIME_DEPARTMENTS = [
  { value: 'sales', label: 'Sales' },
  { value: 'operations', label: 'Operations' },
  { value: 'finance', label: 'Finance' },
  { value: 'technology', label: 'Technology' },
  { value: 'hr', label: 'HR' },
  { value: 'marketing', label: 'Marketing' },
];

const DEPARTMENT_ALIASES = {
  sales: 'sales',
  operations: 'operations',
  ops: 'operations',
  finance: 'finance',
  technology: 'technology',
  tech: 'technology',
  hr: 'hr',
  'human resources': 'hr',
  marketing: 'marketing',
};

export function normalizeTaskTimeDepartment(value) {
  const key = String(value || '').trim().toLowerCase();
  return DEPARTMENT_ALIASES[key] || 'technology';
}

export function taskTimeDepartmentLabel(value) {
  const key = normalizeTaskTimeDepartment(value);
  const match = TASK_TIME_DEPARTMENTS.find((d) => d.value === key);
  return match ? match.label : 'Technology';
}

export const TASK_TIME_STATUS = {
  REQUESTED: 'requested',
  APPROVED: 'approved',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  DENIED: 'denied',
};

// Retired statuses (pre-Aug 2026) fold into the set above on read.
const LEGACY_STATUS_ALIASES = {
  pending_client_approval: 'requested',
};

export function normalizeTaskTimeStatus(value) {
  const key = String(value || '').trim().toLowerCase();
  if (LEGACY_STATUS_ALIASES[key]) return LEGACY_STATUS_ALIASES[key];
  return Object.values(TASK_TIME_STATUS).includes(key) ? key : TASK_TIME_STATUS.REQUESTED;
}

export const TASK_TIME_STATUS_LABELS = {
  requested: 'Requested',
  approved: 'Approved',
  in_progress: 'In progress',
  completed: 'Completed',
  denied: 'Denied',
};

export const TASK_TIME_FILTER_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'requested', label: 'Requested' },
  { value: 'approved', label: 'Approved' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'completed', label: 'Completed' },
  { value: 'denied', label: 'Denied' },
];

/**
 * The single time amount on a request. Legacy docs split this across
 * allottedHours (CRM estimate) / requestedHours (client's ask) — read through
 * both so old rows still show and still deduct correctly.
 */
export function taskTimeRequestHours(request) {
  if (!request) return null;
  const candidates = [request.hours, request.allottedHours, request.requestedHours];
  for (const value of candidates) {
    const n = Number(value);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return null;
}

export const TASK_TIME_MAX_HOURS = 40;
export const TASK_TIME_MIN_HOURS = 0.5;
export const TASK_TIME_STEP = 0.5;
